<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card color="green" title="Latex Test">
  
          <vue-mathjax :formula="latex"></vue-mathjax>

          <!--  <v-data-table
            :headers="headers"
            :items="contestList"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td> {{ item.question }}</td>
              <td>{{ item.contest_date }}</td>
              <td>{{ item.prize_amount }} BDT</td>
              <td>
                <v-btn color="success" @click="goDetailsPage(item.id)" small>details</v-btn>
              </td>
            </template>
          </v-data-table>-->
        </material-card>

        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div>{{ noticeMessage }}</div>
          <v-icon size="16" @click="snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { VueMathjax } from "vue-mathjax";
import Form from "@/views/Form";
export default {
  components: {
    Form,
    "vue-mathjax": VueMathjax,
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    //  ...mapState('dailyQuiz', ['contestList']),
  },
  mounted() {
    //  this.GetQuizList()
    this.reRender();
  },
  data() {
    return {
      latex:
        "When \(x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}\), there are two solutions to \(ax^2 + bx + c = 0\) and they are",

      color: null,
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,

      headers: [
        {
          sortable: true,
          text: "Question",
          value: "question",
        },
        {
          sortable: false,
          text: "Date",
          value: "contest_date",
        },
        {
          sortable: false,
          text: "Prize amount",
          value: "prize_amount",
        },
        {
          sortable: false,
          text: "Action",
          value: "",
        },
      ],
      dialog: false,
      noticeMessage: "",
      item: {
        title: "New Contest",
        subTitle: "Create daily quiz for contest",
        submitText: "Submit",
      },
      valueObj: {},

      input: "",
      output: "",
    };
  },
  created() {
    // this.reRender();
  },

  methods: {
    // ...mapActions("dailyQuiz", ["GetQuizList"]),

    closeModal() {
      this.dialog = false;
    },
    reRender() {

      // this.$nextTick(function () {
      //   MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
      // });

      if (window.MathJax) {
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
          console.log("done")
        );
      }
    },
    // watch: {
    //   latex: function() {
    //     console.log('data changed')
    //     this.reRender();
    //   }
    // },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      // this.color = this.colors[Math.floor(Math.random() * this.colors.length)]

      this.snackbar = true;
    },
  },
};
</script>
